module.exports = __webpack_public_path__ + "img/aboutphone.68a236d4.png";